import { useEffect } from "react";
import useRefreshToken from "./useRefreshToken";
import { useAuth } from "./useAuth";
import { apiClient as apiPrivateClient } from "../api/internal";
import { useLocation, useNavigate } from "react-router-dom";

function useApiPrivateClient() {
  const refresh = useRefreshToken();
  const { accessToken, logout } = useAuth();

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const requestIntercept = apiPrivateClient.interceptors.request.use(
      (config) => {
        if (!config.headers["Authorization"]) {
          config.headers["Authorization"] = `Bearer ${accessToken}`;
        }
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    const responseIntercept = apiPrivateClient.interceptors.response.use(
      (response) => response,
      async (error) => {
        const originalRequest = error?.config;

        if (error?.response?.status === 401 && !originalRequest?._sent) {
          originalRequest._sent = true;

          try {
            const newAccessToken = await refresh();
            originalRequest.headers[
              "Authorization"
            ] = `Bearer ${newAccessToken}`;
            return apiPrivateClient(originalRequest);
          } catch (error) {
            navigate("/login", { state: { from: location }, replace: true });
            await logout();
            throw error;
          }
        }

        return Promise.reject(error);
      }
    );

    return () => {
      apiPrivateClient.interceptors.response.eject(responseIntercept);
      apiPrivateClient.interceptors.request.eject(requestIntercept);
    };
  }, [accessToken, refresh]);

  return apiPrivateClient;
}

export default useApiPrivateClient;
